import styled from "styled-components"
import {Collapse} from "antd"
import Icon from "./Icon/Icon"
import {faArrowDown} from "@fortawesome/pro-light-svg-icons"

const FAQ = ({questions}) => {

	return (
		<Wrapper>
			<Title>
				<h2>FAQ</h2>
			</Title>
			<Collapse
				bordered={false}
				style={{flex: 1, fontSize: ''}}
				expandIconPosition="end"
				expandIcon={({isActive}) =>
					<Icon name={faArrowDown} size={28}
						  style={{
							  transition: 'transform 0.3s ease',
							  transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
						  }}/>}
				items={questions}
			/>
		</Wrapper>

	)
}

export default FAQ

const Wrapper = styled.div`
    display: flex;
    gap: 4rem;

    @media (max-width: 1200px) {
        flex-wrap: wrap;
        flex-direction: column;
        gap: 1rem;
    }
`
const Title = styled.div`
    min-width: 300px;
    padding-top: 20px;
`